import { isSafari } from './browsers';
import { isSameDate, SERVER_TIMEZONE } from '../../utils';

export const getDateObj = date => new Date(isSafari() && date && typeof date === 'string' ? date.replace(/-/g, '/') : date);

export const isFutureTimeslot = (startTime) => {
    try {
        const st = getDateObj(startTime);
        const dateNow = new Date(new Date().toLocaleString('en-US', { timeZone: SERVER_TIMEZONE }));
        return st?.valueOf() > dateNow?.valueOf();
    } catch (e) {
        const st = getDateObj(startTime);
        const dateNow = new Date();
        return st?.valueOf() > dateNow?.valueOf();
    }
};

const getTimeslotDurationInMinutes = (start, end) => {
    const endDate = getDateObj(end);
    const startDate = getDateObj(start);
    return (endDate - startDate) / 60000;
};
const getAmountOfTimeslotsForDuration = (timeslotDuration, duration) => {
    return Math.ceil(duration / timeslotDuration); // for 3.1 returns 4
};

const isGoInSequence = (prevTimeslot, nextTimeslot) => prevTimeslot.endTime === nextTimeslot.startTime;
const getCombinedTimeslots = (timeslosts, count) => {
    if (!timeslosts.length || timeslosts.length < count) {
        return [];
    }
    const combinedTimeslots = [];
    let currentCount = 1;
    for (let i = 1; i < timeslosts.length; i++) {
        if (isGoInSequence(timeslosts[i - 1], timeslosts[i])) {
            currentCount++;
            if (currentCount === count) {
                combinedTimeslots.push(timeslosts.slice((i + 1) - count, i + 1));
                currentCount = 1;
                i++;
            }
        } else {
            currentCount = 1;
        }
    }
    return combinedTimeslots;
};

const getMergedCombinedTimeslots = (timeslosts) => {
    return timeslosts.map(timeslotsGroup => ({
        timeslotId: timeslotsGroup[0].timeslotId,
        startTime: timeslotsGroup[0].startTime,
        endTime: timeslotsGroup[timeslotsGroup.length - 1].endTime,
    }));
};

const getMergedTimeslots = (timeslosts, count) => {
    const combinedTimeslots = getCombinedTimeslots(timeslosts, count);
    if (!combinedTimeslots.length) {
        return [];
    }
    return getMergedCombinedTimeslots(combinedTimeslots);
};

const getMergedTimeslotsObj = (timeslots, count) => {
    const actualFreeTimeslots = getMergedTimeslots(timeslots, count);
    return actualFreeTimeslots.length ? {
        freeTimeslots: actualFreeTimeslots,
        nearestTimeslot: actualFreeTimeslots[0].startTime,
    } : { freeTimeslots: actualFreeTimeslots };
};

const sortTimeslots = (timeslots = []) => {
    const sortedTimeslots = [...timeslots];
    const getValue = e => (e.startTime ? (getDateObj(e.startTime)
        .valueOf()) : Number.MAX_VALUE);
    sortedTimeslots?.sort((e1, e2) => getValue(e1) - getValue(e2));
    return sortedTimeslots;
};

export const getActualTimeslotsObj = (originalTimeslots = [], duration) => {
    const timeslots = sortTimeslots(originalTimeslots);
    const timeslotDuration = timeslots.length && getTimeslotDurationInMinutes(timeslots[0].startTime, timeslots[0].endTime);
    if (!timeslots.length || timeslotDuration >= +duration) {
        return { freeTimeslots: timeslots };
    }
    const count = getAmountOfTimeslotsForDuration(timeslotDuration, duration);
    return getMergedTimeslotsObj(timeslots, count);
};

/* Manipulations with timeslots for doctors */

export const getActualTimeslots = (data, currentServiceId) => (data?.length ? data.map(e => ({ ...e, ...(getActualTimeslotsObj(e.freeTimeslots, e.serviceMappings?.find(({ serviceId }) => serviceId === currentServiceId)?.duration)) })) : []);
export const getTimeslotsForCurrentDate = (timeslots, date) => timeslots && date && timeslots.filter(timeslot => isSameDate(timeslot.startTime, date));
